"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSavantClientConfig = void 0;
exports.createSavantClientConfig = function (arg) {
    return arg;
};
//# sourceMappingURL=functions.js.map